import React from "react";
import { useTheme } from '@mui/material/styles';
import { Box } from "@mui/material";
import { useSelector } from 'react-redux';

const UserMember = () => {
  const theme = useTheme();
  const { user } = useSelector(state => ({ user: state.auth.user }));
  if (user?.membership === 0) {
    return (
      <Box
        sx={{
          color: '#FFC700',
          backgroundColor: theme.palette.mode ==="light" ? "#FFF8DD" : "#392F28",
          fontWeight: '600',
          fontSize: '0.675rem',
          padding: '4px 10px',
          borderRadius: '5px',
        }}
      >
        Trial
      </Box>
    );
  } else if (user?.membership === 1) {
    return (
      <Box
        sx={{
          color: '#F1416C',
          backgroundColor: theme.palette.mode ==="light" ? "#FFF5F8" : "#3A2434",
          fontWeight: '600',
          fontSize: '0.675rem',
          padding: '4px 10px',
          borderRadius: '5px',
        }}
      >
        Expired
      </Box>
    );
  } else if (user?.membership === 2) {
    return (
      <Box
        sx={{
          color: '#50CD89',
          backgroundColor: theme.palette.mode === 'light' ? "#E8FFF3" : "#1C3238",
          fontWeight: '600',
          fontSize: '0.675rem',
          padding: '4px 10px',
          borderRadius: '5px',
        }}
      >
        Pro
      </Box>
    );
  }
  return null;
}

export default UserMember;
